import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

import { ValueUpdateDetail } from '../utils/UNSAFE_valueUpdateDetail';

type CheckboxSetContextValue = {
  name: string;
  value?: Set<string | number>;
  onCommit?: (detail: ValueUpdateDetail<Set<string | number>>) => void;
};

const CheckboxSetContext = createContext<CheckboxSetContextValue>({} as CheckboxSetContextValue);
const useCheckboxSetContext = () => useContext(CheckboxSetContext);

export { CheckboxSetContext, useCheckboxSetContext };
